module.exports = __webpack_public_path__ + "static/pizza-guel-61426866b0cbd82b62a517a27c0e5118.jpg";